import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { PaymentMethod } from './payment-methods'

export class PaymentMethodsRepository extends BaseRepository<PaymentMethod> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/' + 'paymentmethods', token, cache)
    }
}
